import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
const PAGE_TITLE = 'ARTE PRONTA™ – Lezioni di Arte e Immagine pronte per Secondaria e Primaria';
const PAGE_DESCRIPTION = 'Il sistema completo per docenti di Arte e Immagine: 9 volumi e oltre 500 pagine con programmazione annuale, 12 lezioni minuto per minuto, schede da stampare, rubriche di valutazione e la classe sotto controllo in laboratorio, più 5 bonus. PDF digitale, pagamento unico, garanzia 7 giorni.';
function setMeta(attr: 'name' | 'property', key: string, content: string): void {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'it';
    document.title = PAGE_TITLE;
    setMeta('name', 'description', PAGE_DESCRIPTION);
    setMeta('property', 'og:title', PAGE_TITLE);
    setMeta('property', 'og:description', PAGE_DESCRIPTION);
    setMeta('property', 'og:locale', 'it_IT');
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="34nbhsjeuzx5">
      <div lang="it" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3ud1ff9ao9oam">
        <CountdownBar data-id="element-2" data-mp="d4nuteha5g1c" />
        <main data-id="element-3" data-mp="d4xobc1ja5bs">
          <Hero data-id="element-4" data-mp="d3mi75km8lhi" />
          <StatsBar data-id="element-5" data-mp="d45vg8zbmlp7" />
          <Difference data-id="element-6" data-mp="d2biphy7dzw7" />
          <Recognize data-id="element-7" data-mp="85uktw17c75x" />
          <WhatsInside data-id="element-8" data-mp="86mf93j2byum" />
          <InsidePages data-id="element-9" data-mp="86499f6lm69i" />
          <Bonuses data-id="element-10" data-mp="83qhpgb4nc6p" />
          <HowItWorks data-id="element-11" data-mp="3gl4r7gc4jyji" />
          <Audience data-id="element-12" data-mp="3gkl6xsz04y2b" />
          <Offer data-id="element-13" data-mp="3glwc9x83idvj" />
          <Guarantee data-id="element-14" data-mp="3gja7248ogagh" />
          <Testimonials data-id="element-15" data-mp="3bmbg1ukb8jmi" />
          <Faq data-id="element-16" data-mp="3bn2ye3owckuu" />
          <FinalCta data-id="element-17" data-mp="3bnmgpliglb9e" />
        </main>
        <Footer data-id="element-18" data-mp="3bk72sm0iu89k" />
      </div>
    </MotionConfig>;
}